export default {
  'entityBuilder.title': 'Entity Builder',
  'entityBuilder.back': 'Volver',
  'entityBuilder.canvas': 'Canvas',
  'entityBuilder.data': 'Datos',
  'entityBuilder.publish': 'Publicar',
  'entityBuilder.publish.success': 'Entidad publicada exitosamente',
  'entityBuilder.publish.error': 'Error al publicar',
  'entityBuilder.error.notFound': 'La entidad no existe o no se encontró',
  'entityBuilder.published': 'Publicada',
  'entityBuilder.settings': 'Configuración',
  'entityBuilder.more': 'Más opciones',

  'entityBuilder.stats.fields': 'Campos',
  'entityBuilder.stats.required': 'Requeridos',
  'entityBuilder.stats.optional': 'Opcionales',
  'entityBuilder.col.field': 'Campo',
  'entityBuilder.col.type': 'Tipo',
  'entityBuilder.badge.req': 'REQ',
  'entityBuilder.field.add': 'Agregar',
  'entityBuilder.field.edit': 'Editar campo',
  'entityBuilder.field.delete': 'Eliminar campo',
  'entityBuilder.field.delete.confirm': '¿Estás seguro de eliminar este campo?',
  'entityBuilder.field.required': 'Requerido',
  'entityBuilder.field.showMore': 'Mostrar más',
  'entityBuilder.field.showLess': 'Mostrar menos',

  'entityBuilder.addField.title': 'Seleccionar tipo de campo',
  'entityBuilder.addField.search': 'Buscar tipo...',

  'entityBuilder.panel.settings': 'Configuración General',
  'entityBuilder.panel.fieldEditor': 'Editar Campo',
  'entityBuilder.panel.tokens': 'Tokens de API',
  'entityBuilder.panel.collaborators': 'Colaboradores',
  'entityBuilder.panel.lists': 'Listas',
  'entityBuilder.panel.traces': 'Historial',
  'entityBuilder.panel.tasks': 'Tareas',
  'entityBuilder.panel.data': 'Importar / Exportar',
  'entityBuilder.panel.relations': 'Relaciones',

  'entityBuilder.tokens.add': 'Agregar Token',
  'entityBuilder.tokens.name': 'Nombre',
  'entityBuilder.tokens.readEnabled': 'Lectura',
  'entityBuilder.tokens.writeEnabled': 'Escritura',
  'entityBuilder.tokens.deleteEnabled': 'Eliminación',
  'entityBuilder.tokens.copy': 'Copiar token',
  'entityBuilder.tokens.view': 'Ver detalle',
  'entityBuilder.tokens.copied': 'Token copiado al portapapeles',
  'entityBuilder.tokens.delete.confirm': '¿Estás seguro de eliminar este token?',
  'entityBuilder.tokens.noPerms': 'Sin permisos',
  'entityBuilder.tokens.empty': 'Sin tokens',
  'entityBuilder.tokens.empty.hint':
    'Crea tokens de API para integrar esta entidad con sistemas externos',

  'entityBuilder.collaborators.title': 'Colaboradores',
  'entityBuilder.collaborators.addSection': 'Agregar colaboradores',
  'entityBuilder.collaborators.selectUsers': 'Seleccionar usuarios',
  'entityBuilder.collaborators.usersRequired': 'Selecciona al menos un usuario',
  'entityBuilder.collaborators.add': 'Agregar Colaborador',
  'entityBuilder.collaborators.current': 'Colaboradores actuales',
  'entityBuilder.collaborators.remove.confirm': '¿Quitar colaborador?',
  'entityBuilder.collaborators.remove.content': '¿Estás seguro de quitar a {userName}?',
  'entityBuilder.collaborators.empty': 'No hay colaboradores en esta entidad',

  'entityBuilder.data.import': 'Importar',
  'entityBuilder.data.export': 'Exportar',
  'entityBuilder.data.purge': 'Purgar datos',
  'entityBuilder.data.purge.confirm': 'Escribe PURGE para confirmar',
  'entityBuilder.data.deleteExisting': 'Eliminar datos existentes al importar',

  'entityBuilder.purge.title': 'Limpiar datos de la entidad',
  'entityBuilder.purge.warning':
    'Esta acción eliminará permanentemente todos los registros de la entidad. No se puede deshacer.',
  'entityBuilder.purge.instruction': 'Para confirmar, escribe «{name}»',
  'entityBuilder.purge.mismatch': 'El nombre no coincide con el de la entidad',
  'entityBuilder.purge.confirm': 'Limpiar datos',

  'entityBuilder.relations.dependencies': 'Dependencias',
  'entityBuilder.relations.dependents': 'Dependientes',
  'entityBuilder.relations.current': 'Entidad actual',
  'entityBuilder.relations.empty': 'Sin relaciones',
  'entityBuilder.relations.empty.hint':
    'Las relaciones aparecerán aquí cuando configures campos de referencia entre entidades',

  'entityBuilder.relations.type.entityField': 'Campo',
  'entityBuilder.relations.type.formField': 'Formulario',
  'entityBuilder.relations.type.action': 'Acción',
  'entityBuilder.relations.type.listField': 'Lista',
  'entityBuilder.relations.type.process': 'Proceso',

  'entityBuilder.relations.sourceType.entity': 'Entidad',
  'entityBuilder.relations.sourceType.process': 'Proceso',
  'entityBuilder.relations.fieldFrom': 'De {name}',
  'entityBuilder.relations.fieldTo': 'En {name}',
  'entityBuilder.relations.depTitle': 'Depende de',
  'entityBuilder.relations.depndtTitle': 'Dependen de mí',

  'entityBuilder.canvas.fit': 'Ajustar al canvas',
  'entityBuilder.canvas.fullscreen': 'Pantalla completa',
  'entityBuilder.canvas.exitFullscreen': 'Salir de pantalla completa',
  'entityBuilder.canvas.zoomIn': 'Acercar',
  'entityBuilder.canvas.zoomOut': 'Alejar',

  'entityBuilder.canvas.empty': 'Tu entidad comienza aquí',
  'entityBuilder.canvas.empty.description':
    'Agrega campos para definir la estructura de tu entidad dinámica',
  'entityBuilder.canvas.empty.hint': 'Haz click en "+ Nueva columna" para comenzar',

  'entityBuilder.version.number': 'Versión',
  'entityBuilder.version.status': 'Estado',
  'entityBuilder.version.published': 'Publicada',
  'entityBuilder.version.draft': 'Borrador',
  'entityBuilder.version.createdBy': 'Creado por',
  'entityBuilder.version.createdDate': 'Fecha de creación',
  'entityBuilder.version.publishedBy': 'Publicado por',
  'entityBuilder.version.publishedDate': 'Fecha de publicación',
  'entityBuilder.version.error': 'Error al cambiar de versión',
  'entityBuilder.header.purge': 'Limpiar datos',
  'entityBuilder.chat.error': 'No se pudo inicializar el chat',
  'entityBuilder.chat.noConnection': 'No hay conexión. Intenta de nuevo.',
  'entityBuilder.chat.title': 'Asistente IA',
  'entityBuilder.chat.open': 'Abrir chat',
  'entityBuilder.chat.close': 'Cerrar chat',
};
